import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgDotsHorizontalTriple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M10 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0-6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      fill="currentColor"
    />
  </svg>
);
